var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { Box, Container, Paper, TextField, Button, Typography, Alert, } from '@mui/material';
import { apiClient } from '@utils/apiClient';
const ResetPassword = () => {
    const [searchParams] = useSearchParams();
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [token, setToken] = useState('');
    const navigate = useNavigate();
    useEffect(() => {
        const tokenParam = searchParams.get('token');
        if (!tokenParam) {
            setError('Invalid reset link');
        }
        else {
            setToken(tokenParam);
        }
    }, [searchParams]);
    const handleSubmit = (e) => __awaiter(void 0, void 0, void 0, function* () {
        e.preventDefault();
        setError('');
        setSuccess('');
        if (password !== confirmPassword) {
            setError('Passwords do not match');
            return;
        }
        if (password.length < 6) {
            setError('Password must be at least 6 characters');
            return;
        }
        try {
            yield apiClient.post('/auth/reset-password', {
                token: token,
                newPassword: password,
            });
            setSuccess('Password reset successfully! Redirecting to login...');
            setTimeout(() => navigate('/login'), 2000);
        }
        catch (err) {
            setError(err instanceof Error ? err.message : 'Password reset failed');
        }
    });
    return (_jsx(Container, { maxWidth: "sm", children: _jsx(Box, { sx: {
                marginTop: 8,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
            }, children: _jsxs(Paper, { elevation: 3, sx: { padding: 4, width: '100%' }, children: [_jsx(Box, { sx: { display: 'flex', justifyContent: 'center', mb: 2 }, children: _jsx("img", { src: "/tractor.png", alt: "Tractor", style: { width: '120px', height: 'auto' } }) }), _jsx(Typography, { component: "h1", variant: "h4", align: "center", gutterBottom: true, children: "Reset Password" }), _jsx(Typography, { variant: "body2", align: "center", color: "text.secondary", sx: { mb: 3 }, children: "Enter your new password below." }), error && (_jsx(Alert, { severity: "error", sx: { mb: 2 }, children: error })), success && (_jsx(Alert, { severity: "success", sx: { mb: 2 }, children: success })), _jsxs(Box, { component: "form", onSubmit: handleSubmit, sx: { mt: 1 }, children: [_jsx(TextField, { margin: "normal", required: true, fullWidth: true, name: "password", label: "New Password", type: "password", id: "password", autoComplete: "new-password", autoFocus: true, value: password, onChange: (e) => setPassword(e.target.value) }), _jsx(TextField, { margin: "normal", required: true, fullWidth: true, name: "confirmPassword", label: "Confirm Password", type: "password", id: "confirmPassword", value: confirmPassword, onChange: (e) => setConfirmPassword(e.target.value) }), _jsx(Button, { type: "submit", fullWidth: true, variant: "contained", sx: { mt: 3, mb: 2 }, disabled: !token, children: "Reset Password" }), _jsx(Box, { sx: { textAlign: 'center', mt: 2 }, children: _jsx(Link, { to: "/login", style: { textDecoration: 'none' }, children: _jsx(Typography, { variant: "body2", color: "primary", children: "Back to Sign In" }) }) })] })] }) }) }));
};
export default ResetPassword;
